export default "__VITE_ASSET__1a075fd9__"